import hebelApi from '../hebel/hebelApi';
import SolarFunctions from "./SolarFunctions";
import Quote from "./Quote";

class Project {
    createdAt = 0;
    contactId = 0;
    dealId = 0;
    contact = { name: "", email: "", phone:"" };
    site = {
        cityName: "Campinas - SP",
        city: {},
        streetAddress: "",
        streetAddressNumber: "",
        streetAddressLine2: "", //complemento
        zipCode: "",
        neighborhood: "", //Bairro
        electricalProps: {
            averageBilling: {
                unit: "kWh",
                price: 0.7,
                quantity: 662.74,
                total: 463.92,
                type: "B2",
                factor: 1,
                description: "Energia ativa",
                minAmount: 100,
            },
            voltage: 220,
            phases: 3,
        },
        solarRequest: {
            complete: true, //solarPlant installed or not
            quoteProfileId: 0, //number
            manufacturer: "HOPESUN", //Load from client
            moduleId: "0pFWRkFrufdiuZvI7aO4",
            structureId: "7ti8AXNyUqi3qiWW0A3L",
            module: {},
            dcPower: 5, // From calculation
            consumption: 662.74,
            production: 500,
            calcType: "kWh",
            customKit: false, //true = kit aberto, false, kit fechado.
            estimated: true, //true == create new generator based on the generators, false - just search available kits
            efficiency: 77,
            components: {
                stringbox: true,
                transformer: true,
            },
        },
    };
    constructor(){
    };

    async calc(){
        var enterprise = await hebelApi.enterprises.getFromId(window.eid)
        var fields = await hebelApi.fields.getAll();
        // var modules = await hebelApi.devices.getFromId( this.site.solarRequest.moduleId)
        // this.site.solarRequest.module = modules[0];
        if (!this.site.city) {
            alert("Selecionar cidade");
            return;
          }


        this.solarPlant = {};
        var s = new SolarFunctions();
        var g;
        var generators = [];
        var generatorsFilter =[];
        if (!this.site.solarRequest.customKit) {
            generators = await hebelApi.devices.getAll( "*","generator",true);
            generatorsFilter = [];
            for (g = 0; g < generators.length; g++) {
              var generator = generators[g];
                if (
                  generator.modules.length > 0 &&
                  generator.modules[0].id == this.site.solarRequest.moduleId
                ) {
                  if (
                    generator.structureId ==
                    this.site.solarRequest.structureId
                  ) {
                    generatorsFilter.push(generator);
                  }
                }
            }
            //Not consider modules
            if (generatorsFilter.length == 0) {
              for (g = 0; g < generators.length; g++) {
                var generator = generators[g];
                  if (
                    generator.structureId == this.site.solarRequest.structureId
                  ) {
                    generatorsFilter.push(generator);
                  }
              }
            }
            //alert(JSON.stringify(generatorsFilter))
            generatorsFilter.sort(function (a, b) {
              return a.dcPower - b.dcPower;
            });
            
            //alert(JSON.stringify(this.site));

            this.solarPlants = s.getSolarPlantsWithGenerators(
              this.site.solarRequest.dcPower,
              generatorsFilter,
              this.site.electricalProps.voltage,
              this.site.electricalProps.phases,
              this.site.solarRequest.estimated,
              this.site.solarRequest.module
            );
            if (this.solarPlants.length == 0) {
              alert("Nenhuma configuração foi encontrada");
              this.calculating = false;
              return;
            }
            this.solarPlant = this.solarPlants[0];

            //alert(JSON.stringify( this.solarPlants[0]))

            
            this.solarPlant.city = this.site.city;
            this.solarPlant.efficiency = this.site.solarRequest.efficiency;
            this.solarPlant.calcProduction(this.site);
            var q = new Quote(enterprise, fields);
    
            q.loadProducts(
              this.solarPlant,
              enterprise,
              this.site
            );
            this.quote = q;
            this.calculating = false;
            return;
          }
    }
    


}

export default Project;
